var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "13px",
    viewBox: "0 0 13 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sprint-7",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.-Add-contact",
    transform: "translate(-1002.000000, -22.000000)",
    fill: "#ADADB0",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_392999",
    transform: "translate(1002.000000, 22.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6372675,0.362616223 C12.1536241,-0.120872074 11.353111,-0.120872074 10.8694676,0.362616223 L6.5,4.73068291 L2.13053239,0.362616223 C1.64688903,-0.120872074 0.846375882,-0.120872074 0.362732521,0.362616223 C-0.12091084,0.846104521 -0.12091084,1.64636101 0.362732521,2.12984931 L4.73220013,6.497916 L0.362732521,10.8659827 C-0.12091084,11.349471 -0.12091084,12.1497275 0.362732521,12.6332158 C0.61289288,12.8832959 0.929762668,13 1.24663246,13 C1.56350225,13 1.88037203,12.8832959 2.13053239,12.6332158 L6.5,8.26514909 L10.8694676,12.6332158 C11.119628,12.8832959 11.4364978,13 11.7533675,13 C12.0702373,13 12.3871071,12.8832959 12.6372675,12.6332158 C13.1209108,12.1497275 13.1209108,11.349471 12.6372675,10.8659827 L8.26779987,6.497916 L12.6372675,2.12984931 C13.1209108,1.64636101 13.1209108,0.846104521 12.6372675,0.362616223 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.51abbee1839386a73668edf902963725.svg";
export { ForwardRef as ReactComponent };